<template>
  <div class="contents">
    <common-header
      :menu="headerMenu"
      :mute="mute"
      :camera-mode="currentCameraMode"
      @button-clicked="onButtonClicked"
      @camera-mode-change="onCameraChange" />
    <settings-modal ref="settings" :settings="settings"
                    :display-value="displayValue"
                    @camera-mode-change="onCameraChange"
                    @settings-change="onSettingChange" />
    <common-display :debug-meg="debugMeg" :navigations="navigations" />
    <side-menu v-show="canShowSideMenu" :menu="sideMenu"
               @button-clicked="onButtonClicked" />
    <section v-show="showScore && canShowHeaderMenu" class="score-boards" style="position: fixed;top:0;width: 100vw;">
      <score-board title="時速" :value="speedStr" unit="km/h" font-size="4vh" class="score-borad" />
    </section>
    <div class="play-list" :class="showPlayList ? 'show' : 'hide'">
      <section v-for="(url, i) in playList" :key="url">
        <input class="play-list-input" type="text" :value="url" disabled @input="updatePlayList($event, i)">
      </section>
      <section v-show="playList.length < 5">
        <input id="new-play-url" class="play-list-input" type="text" v-model="newPlayUrl" placeholder="https://www.youtube.com/watch?v=XXXXXXXX">
        <button class="normal-button noto500" @click="addPlayUrl(newPlayUrl)">追加</button>
      </section>
      <button class="wide-button noto500" @click="showPlayList = !showPlayList">
        {{showPlayList ? '◀' : '▶'}}
      </button>
    </div>
<!--    <iframe id="player" type="text/html" width="640" height="360" style="position: absolute;top:100px;left: 100px;z-index: 1100;"-->
<!--            src="http://www.youtube.com/embed/M7lc1UVf-VE?enablejsapi=1&origin=http://localhost:8080"-->
<!--            frameborder="0"></iframe>-->
    <div id="player"></div>

    <title-label :title="title"/>
    <common-modal ref="modal" :steps="steps"/>
    <fill-camera-layout
      @camera-required="start"
      :device-state="deviceState"
      :camera-state="manager ? manager.state : null"/>
    <common-footer v-show="canShowFooterMenu" :menu="footerMenu" />

    <div id="tutorial-point-3" style="z-index: -1;position: absolute;top:20%; left: 50%;"></div>
    <div id="tutorial-point-2" style="z-index: -1;position: absolute;top:30vh; left: 50%;"></div>

    <div v-if="currentTutorial" id="tutorial" class="tutorial-nav" style="
      width: fit-content;
      z-index: 10000;
      position: absolute;
      background: rgba(0,0,0,0.75);
      color: white;
      top:50%;
      left: 50%;
      padding: 2vh;
      transform: translate(-50%, -50%);
">
      <div>使い方 {{currentTutorialStep}}</div>
      <div>
        {{currentTutorial.text}}
      </div>
    </div>
  </div>
</template>

<script>
import "@pqina/flip/dist/flip.min.css";
import {YoutubeJogging} from '../game/YoutubeJogging'
import SettingButton from "../SettingButton";
import Separator from "../Separator";
import CommonHeader from "../CommonHeader";
import {CAMERA_MODE} from '../common/CameraRenderer'
import {CommonMixin} from '../common/CommonMixin'
import FillCameraLayout from "../FillCameraLayout";
import CommonDisplay from "../CommonDisplay";
import CommonFooter from "../CommonFooter";
import ScoreBoard from "../common/ScoreBoard";
import SettingsModal from "../common/SettingsModal";
import CommonModal from "../common/CommonModal";
import SideMenu from "../SideMenu";
import BasicButton from "../common/BasicButton";
import Vue from "vue";
import {ContentsSetting} from "../common/ContentsSetting";
import TitleLabel from "../common/TitleLabel";

export default {
  name: 'YoutubeJogging',
  mixins: [CommonMixin],
  components: {
    TitleLabel,
    BasicButton, SideMenu, CommonModal, SettingsModal, ScoreBoard, CommonFooter, CommonDisplay, FillCameraLayout, CommonHeader, Separator, SettingButton},
  data () {
    const contentsSetting = new ContentsSetting('youtube-jogging')
    // console.log(contentsSetting)
    // contentsSetting.clear()
    return {
      contentsSetting,
      player: null,
      done: false,
      needToCue: false,
      // playList: ['M7lc1UVf-VE', 'l9IAr7WY-Xk'],
      playList: contentsSetting.getValue('playList', []),
      // newPlayUrl: 'https://www.youtube.com/watch?v=l9IAr7WY-Xk',
      newPlayUrl: null,
      showPlayList: true,

      lastPlayIndex: null,

      currentTutorialStep: null,
      currentTutorial: null,

      showScore: false,
      defaultCameraMode: CAMERA_MODE.FIGURE,
      headerMenu: Object.assign({}, this.defaultHeaderMenu(), {  }),
      sideMenu: Object.assign({}, this.defaultSideMenu(), { 'capture-video': false }),
      footerMenu: Object.assign({}, this.defaultFooterMenu(), { analytics: false }),
      settings: [
        { key: 'poseToDist', type: 'range', label: '反応しやすさ', default: 8, step:1, min:1, max:25 },
      ],
      steps: [

      ],
      speed: 0,
      timeSec: 0,
    }
  },
  computed: {
    title() {
      return 'YouTubeジョギング'
    },
    desc() {
      return '走ってる間だけYouTubeが再生される'
    },
    timeStr() {
      if (this.timeSec === null) {
        return '00:00'
      }
      let t = this.timeSec
      let sec = t % 60
      t -= sec
      t = Math.floor(t/60)
      return `${t.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`
    },
    speedStr() {
      if (this.speed === null) {
        return 0
      }
      return this.speed.toFixed(1).toString().padStart(4,'0')
    }
  },
  created() {
    const tag = document.createElement('script');
    tag.src = "./static/iframe_api.js";
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    tag.onload = () => {
    }
    window.onYouTubeIframeAPIReady = (event) => {
      this.onYouTubeIframeAPIReady(event)
    }
  },
  mounted() {

  },
  methods: {
    async startTutorial() {
      this.currentTutorialStep = 1
      this.currentTutorial = { selector: 'new-play-url', text: '↓再生したいURLを入力' }
      await Vue.nextTick()
      this.showTutorial()
    },
    endTutorial() {
      this.currentTutorial = null
    },
    showTutorial() {
      const target = document.getElementById(this.currentTutorial.selector)
      const tutorial = document.getElementById('tutorial')
      tutorial.style.top = `${target.offsetTop + target.offsetHeight}px`
      tutorial.style.left = `${target.offsetLeft + target.offsetWidth * 0.5}px`
    },

    createContents() {
      return new YoutubeJogging(() => this.pauseVideo(), () => this.playVideo());
    },
    onPlayerReady(event) {
      if (this.playList.length > 0) {
        this.player.loadPlaylist(this.playList)
        event.target.playVideo()
      }
    },
    async onYouTubeIframeAPIReady() {
      console.log('onYouTubeIframeAPIReady')
      if (!this.playList.length) {
        this.startTutorial()
      } else {
        this.needToCue = true
        this.createPlayer()
        this.currentTutorialStep = 1
        this.currentTutorial = { selector: 'tutorial-point-2', text: '↓最初だけ自分で再生を開始する' }
        await Vue.nextTick()
        this.showTutorial()
      }
    },
    onPlayerStateChange(event) {
      if (event.data === YT.PlayerState.ENDED) {
        const index = this.player.getPlaylistIndex()
        if (this.lastPlayIndex === null) {
          this.lastPlayIndex = index
        } else if (this.lastPlayIndex < index) {
          const oldPlayList = this.contentsSetting.getValue('playList', [])
          oldPlayList.shift()
          this.contentsSetting.overWriteAndSave('playList', oldPlayList)
          this.playList = oldPlayList
        }
      }

      if (event.data === YT.PlayerState.PLAYING) {
        if (!this.done) {
          this.manager.game.onStartPlay()
          this.done = true
          if (this.needToCue) {
            for (let i = 1; i < this.playList.length; i++) {
              this.player.cueVideoById(this.extractVideoId(this.playList[i]))
            }
          }
        }

        this.currentTutorialStep = 2
        this.currentTutorial = { selector: 'tutorial-point-3', text: '走り出したら再生されるよ！' }
        this.showTutorial()
      }
    },
    playVideo() {
      this.player.playVideo();
      if (this.currentTutorial) {
        this.endTutorial()
      }
    },
    pauseVideo() {
      this.player.pauseVideo();
    },
    nextVideo() {
      this.player.nextVideo();
    },
    addPlayUrl(url) {
      const videoId = this.extractVideoId(url)
      this.playList.push(url)
      if (!this.player) {
        this.createPlayer()
      }
      this.newPlayUrl = null
      if (this.player && this.player.cueVideoById) {
        this.player.cueVideoById(videoId)
      }
      this.contentsSetting.appendAndSave('playList', url)
    },
    createPlayer() {
      this.player = new YT.Player('player', {
        height: window.innerHeight * 0.8,
        width: window.innerWidth * 0.8,
        videoId: this.extractVideoId(this.playList[0]),
        events: {
          'onReady': this.onPlayerReady,
          'onStateChange': this.onPlayerStateChange
        }
      });
    },
    extractVideoId(url) {
      return url.replace('https://www.youtube.com/watch?v=', '')
                .replace('https://youtu.be/', '')
    },
    setScores() {
      this.score = Math.round(this.manager.game.score)
      this.speed = this.manager.game.speed
      this.timeSec = this.manager.game.timeSec
      this.navigations = this.manager.game.navigations
      this.debugMeg = this.manager.game.debug

      this.showScore = this.speed >= 2.0
    }
  }
}
</script>

<style scoped>
#player {
  position: absolute;
  /*top:100px;*/
  /*left: 100px;*/
  z-index: 9998;
}
.play-list {
  position: absolute;
  left: 0;
  top: 10vh;
  z-index: 9999;
  border: 1px solid black;
  background: rgba(255,255,255,0.85);
  width: 360px;
  transition: all 300ms 0s ease;
}
.play-list.active {
  transform: translateX(0)
}
.play-list.hide {
  transform: translateX(-360px)
}
.play-list-input {
  display: block;
  border: 1px solid #333;
  border-radius: 2vh;
  width: 85%;
  /*background: #e74a23;*/
  /*background: linear-gradient(to right, #e74a23 0%, #efa118 80%, #ffe140 100%);*/
  /*color: white;*/
  padding: 1vh 2vh;
  margin: 1vh;
}

.play-list-input:disabled {
  background: #eee;
  color: black;
}
.normal-button {
  border: 0.5vh solid white;
  background: #e74a23;
  background: linear-gradient(to right, #e74a23 0%, #efa118 80%, #ffe140 100%);
  color: white;
  padding: 1vh 2vh;
  border-radius: 2vh;
  box-shadow: 0.5vh -0.5vh 1vh rgba(0,0,0,0.3), -0.5vh -0.5vh 1vh rgba(0,0,0,0.1), 0.5vh 0.5vh 1vh rgba(0,0,0,0.1);
}
.wide-button {
  position: absolute;
  top:0;
  right: -3.5vh;
  height: 100%;
  border: 0.5vh solid white;
  background: #e74a23;
  background: linear-gradient(to right, #e74a23 0%, #efa118 80%, #ffe140 100%);
  color: white;
  padding: 1vh 0.2vh;
  border-radius: 0.5vh;
  box-shadow: 0.5vh -0.5vh 1vh rgba(0,0,0,0.3), -0.5vh -0.5vh 1vh rgba(0,0,0,0.1), 0.5vh 0.5vh 1vh rgba(0,0,0,0.1);
}
.score-borad {
  margin: 0 auto;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/contents-page/YoutubeJogging.vue